import { IconButtonProps, Typography } from '@mui/material';
import * as React from 'react';
import { MouseEvent } from 'react';
import { useFormContext } from 'react-hook-form';
import { BoxProps } from '@mui/material/Box';
import { EtcMenuWrapper } from '@/components/Social/styles';
import { useSocialBoardCountWithFilter } from '@/hooks/apiHooks';
import { useAtom } from 'jotai';
import { socialState } from '@/recoil/atom';
import { t } from 'i18next';
import FavoriteButton, {
  FavoriteButtonProps,
} from '@/components/@IntranetLibrary/Button/Favorite';
import { useSnackbar } from '@/hooks/global-tools';

type P = {
  isLoading?: boolean;
  isChecked: boolean;
  onChange: (v: boolean) => void;
  isListType?: boolean;
} & Omit<IconButtonProps, 'onChange'> &
  Pick<FavoriteButtonProps, 'theme'>;

const BookmarkToggleButton = ({
  isLoading = false,
  isChecked,
  onChange,
  isListType,
  sx,
  ...props
}: P) => {
  const { showSuccess } = useSnackbar();
  const handleChange = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    !isChecked && showSuccess({ message: t('즐겨찾기에 추가되었습니다.') });
    onChange(!isChecked);
  };

  return (
    <FavoriteButton
      {...props}
      sx={{
        width: isListType ? 20 : 24,
        height: 24,
        ...sx,
      }}
      onClick={handleChange}
      isFavorite={isChecked}
      isLoading={isLoading}
    />
  );
};

export default BookmarkToggleButton;

type RHFP = {
  name: string;
  isChecked: undefined | boolean;
} & Omit<IconButtonProps, 'onChange'>;

export const RHFBookmarkToggleButton = (props: RHFP) => {
  const { name, isChecked, ...other } = props;
  const { setValue } = useFormContext();
  const bookmarkChange = (changedValue: boolean) => {
    setValue(name, changedValue);
  };

  return (
    <BookmarkToggleButton
      name={name}
      isChecked={!!isChecked}
      onChange={bookmarkChange}
      {...other}
    />
  );
};

type buttonP = { bookmarkToggle: () => void; isBookmark: boolean } & BoxProps;

export function CategoryBookmarkButton({
  bookmarkToggle,
  isBookmark,
  ...props
}: buttonP) {
  const [state] = useAtom(socialState);
  const { data } = useSocialBoardCountWithFilter(true, state.currentDate);

  return (
    <EtcMenuWrapper onClick={bookmarkToggle} isSelect={isBookmark}>
      <Typography fontSize={16} fontWeight={400}>
        <span>즐겨찾기</span>
        {data && data.totalCount !== 0 && (
          <span style={{ marginLeft: '10px' }}>{data.totalCount}</span>
        )}
      </Typography>
      <RHFBookmarkToggleButton
        name={'isBookmark'}
        isChecked={isBookmark}
        disabled={!isBookmark}
        sx={{
          ':hover': {
            background: 'transparent !important',
          },
        }}
      />
    </EtcMenuWrapper>
  );
}
